import { createRoot } from "react-dom/client";
import "./core/i18n";
import "./styles.css";
import App from "./App";
import { initTelemetry } from "./core/telemetry";
void initTelemetry().catch(() => {});
createRoot(document.getElementById("root")!).render(<App />);
